import React from 'react';
import { GenericModal } from 'src/components/Modals/GenericModal';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Divider, FormGroup } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { useKeywordPerformanceFilterStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/stores/KeywordPerformanceFilterStore';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import CheckboxItem from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/CheckboxItem';

const KeywordPerformanceFilterModal = () => {
  const {
    isOpen,
    tempUsageBelow70: tempUsageBelow35,
    tempProductivityBelow70: tempProductivityBelow35,
    tempPopularityBelow70: tempPopularityBelow35,
    closeModal,
    setTempUsageBelow70,
    setTempProductivityBelow70,
    setTempPopularityBelow70,
    resetFilters,
    applyFilters
  } = useKeywordPerformanceFilterStore();

  const handleApply = () => {
    applyFilters();
  };

  const handleClear = () => {
    resetFilters();
  };

  return (
    <GenericModal
      open={isOpen}
      onClose={closeModal}
      sx={{
        '& .MuiPaper-root': {
          padding: '18px 24px 16px 24px',
          width: '450px'
        },
        '& .genericModal__body': {
          height: '372px'
        },
        '& .genericModal__header': {
          position: 'relative',
          paddingBottom: '18px',
          justifyContent: 'center',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '-24px',
            width: 'calc(100% + 48px)',
            height: '1px',
            backgroundColor: colors.graysSecondary
          },
          '& h4': {
            width: '100%',
            textAlign: 'center'
          },
          svg: {
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-100%)'
          }
        }
      }}
    >
      <GenericModal.Header title="Keyword Performance Filter" onClose={closeModal} />
      <GenericModal.Body>
        <Flex flexDirection="column" gap={24} sx={{ padding: '24px 0 40px' }}>
          <Text variant="body2">Use the filters below to view products with low keyword performance scores.</Text>

          <FormGroup
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}
          >
            <CheckboxItem
              checked={tempUsageBelow35}
              onClick={(e) => setTempUsageBelow70(e.target.checked)}
              label="Keyword Usage below 70%"
              value="usageBelow70"
              textSx={{
                maxWidth: 'unset'
              }}
            />
            <CheckboxItem
              checked={tempProductivityBelow35}
              onClick={(e) => setTempProductivityBelow70(e.target.checked)}
              label="Keyword Productivity below 70%"
              value="productivityBelow70"
              textSx={{
                maxWidth: 'unset'
              }}
            />
            <CheckboxItem
              checked={tempPopularityBelow35}
              onClick={(e) => setTempPopularityBelow70(e.target.checked)}
              label="Keyword Popularity below 70%"
              value="popularityBelow70"
              textSx={{
                maxWidth: 'unset'
              }}
            />
          </FormGroup>
        </Flex>
      </GenericModal.Body>
      <Divider
        sx={{
          margin: '0 -24px',
          width: 'calc(100% + 48px)'
        }}
      />
      <Flex
        gap={16}
        justifyContent="space-between"
        sx={{
          paddingTop: '16px'
        }}
      >
        <SlButton onClick={handleClear}>Clear</SlButton>
        <SlButton onClick={handleApply} variant="contained">
          Apply
        </SlButton>
      </Flex>
    </GenericModal>
  );
};

export default KeywordPerformanceFilterModal;
